/**
 * The route query a list lands on after « Reset view ».
 *
 * A list's search, filters, advanced query, sort, grouping and open saved view
 * all live in the route query, so resetting them is a navigation. A top-level
 * list owns its whole URL and goes back to its opening query. An embedded list
 * shares its host's URL — the host's tab, back markers and drill-down are not
 * its to clear — so only the list's own parameters are removed.
 *
 * Tested without a browser in `tests/e2e/unit/list-reset.spec.js`.
 *
 * @param {Object} options
 * @param {Object} options.current The route query now
 * @param {string[]} options.owned The parameters the list reads
 * @param {boolean} [options.embedded]
 * @param {Object|Function|null} [options.opening] The list's opening query
 * @returns {Object}
 */
export function queryAfterReset({ current = {}, owned = [], embedded = false, opening = null }) {
    const openingQuery = (typeof opening === 'function' ? opening() : opening) || {};

    if (!embedded) {
        return { ...openingQuery };
    }

    const listKeys = new Set([...owned, 'query', 'q', 'view', 'group_by', 'sort_field', 'sort_order']);
    const kept = Object.fromEntries(Object.entries(current).filter(([key]) => !listKeys.has(key)));

    return { ...kept, ...openingQuery };
}
